module.exports = __webpack_public_path__ + "fonts/NormaticaDisplay-Demo.241e45d5.woff2";